import { productIdFormat } from "@redotech/redo-product-id";
import * as z from "zod";

export const bulkUpdateProductFlags = {
  name: "bulkUpdateProductFlags" as const,
  input: z
    .object({
      productIds: z.array(productIdFormat.schema).min(1),
      nonPicked: z.boolean().optional(),
      skipMarketplace: z.boolean().optional(),
    })
    .refine(
      (input) =>
        input.nonPicked !== undefined || input.skipMarketplace !== undefined,
      { message: "Nothing to update" },
    ),
  output: z.object({
    updatedCount: z.number(),
    skippedNoAuthCount: z.number(),
  }),
};
